//TestBookHome1.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../components/utils/Tooltip';
import './styles/TestBook.css';
import './styles/BookShelf.css';
import testbookimage from '../../assets/pageimages/TestBook.webp';

// import adImage from '../../assets/pageimages/bookworldlistad.webp';


const TestBookAbout = () => {
    const tooltiptext = "About Think5Whys";

    return (
        <div>
            <div className="w-full flex flex-col items-center bg-gradient-to-r from-blue-800 via-blue-600 to-blue-400 py-8 px-4 rounded-lg shadow-lg">
                <h3 className="text-lg font-semibold mb-6 text-center text-white border-b-2 border-yellow-300 pb-2 w-10/12 md:w-8/12">
                    ThinkTestBook
                </h3>
                <div className="flex flex-col justify-center items-center space-y-4 text-center">
                    <img
                        id="testbook-id"
                        className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 rounded-full shadow-md transform hover:scale-110 transition-transform duration-300 ease-in-out"
                        src={testbookimage}
                        alt="TestBook"
                    />
                    <p className="text-xl sm:text-xl lg:text-2xl font-bold text-yellow-200">
                        Your Ultimate Exam Prep Hub: With Your Mentors, Institution & Yourself!
                    </p>
                    <p className="text-xl sm:text-lg lg:text-xl font-bold text-white">
                        Learn. Practice. Improve. Achieve Success!
                    </p>
                    <p className="text-xl sm:text-lg lg:text-xl font-bold text-yellow-200">
                        AI & Data Science At Work With Your School, Coaching, Teachers & NGOs
                    </p>
                </div>
            </div>

        </div>
    );
};

export default TestBookAbout;
